"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dls_react_1 = require("@americanexpress/dls-react");
const formik_1 = require("formik");
const react_1 = __importDefault(require("react"));
const CheckboxField = ({ name, value, label, hint, className, }) => {
    const [field, meta] = (0, formik_1.useField)({ name, value, type: 'checkbox' });
    const errorId = `${name}-error`;
    const hasError = Boolean(meta.touched && meta.error);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(dls_react_1.Checkbox, { label: label, id: name, name: field.name, checked: field.checked, onChange: field.onChange, onBlur: field.onBlur, "aria-invalid": hasError || undefined, "aria-describedby": hasError ? errorId : undefined }),
        hint && react_1.default.createElement(dls_react_1.Hint, null, hint),
        hasError && (react_1.default.createElement(dls_react_1.ComponentLevelNotification, { id: errorId, status: "error", role: "alert" }, meta.error))));
};
exports.default = CheckboxField;
